<template>
    <div class="layout-general-settings-tab">
        <RedesignBaseForm
            ref="generalSettingsForm"
            :model="layoutLocalModel"
            class="space-y-10"
        >
            <RedesignVerticalFormItem
                :title="String($t('layout.config.general'))"
                :description="String($t('layout.config.general.info'))"
            >
                <RedesignFormItem
                    :label="String($t('layout.layoutName'))"
                    prop="LayoutName"
                    :rules="[required]"
                >
                    <div class="w-auto">
                        <RedesignBaseInput
                            v-model="layoutLocalModel.LayoutName"
                            class=""
                        />
                    </div>
                </RedesignFormItem>
                <RedesignFormItem
                    :label="String($t('dashboard.dashboardLogo'))"
                    prop="Logo"
                >
                    <RedesignImageUploader
                        :image="getLogo"
                        image-name="Logo"
                        @on-success="onUpdateLogo"
                    />
                </RedesignFormItem>
                <RedesignFormItem
                    :label="String($t('dashboard.favicon'))"
                    prop="Favicon"
                >
                    <RedesignImageUploader
                        :image="getFavicon"
                        image-accept="image/x-icon, image/png, .svg"
                        image-name="Favicon"
                        @on-success="onUpdateFavicon"
                    />
                </RedesignFormItem>
            </RedesignVerticalFormItem>
            <LayoutGeneralColors
                v-model="layoutLocalModel"
            />
            <LayoutGeneralFonts
                v-model="layoutLocalModel"
            />
        </RedesignBaseForm>
    </div>
</template>

<script setup lang="ts">
import RedesignBaseForm from '@/components/RedesignBaseComponents/Form/RedesignBaseForm.vue'
import RedesignVerticalFormItem from '@/components/RedesignBaseComponents/Form/RedesignVerticalFormItem.vue'
import RedesignBaseInput from '@/components/RedesignBaseComponents/Inputs/RedesignBaseInput.vue'
import RedesignFormItem from '@/components/RedesignBaseComponents/Form/RedesignFormItem.vue'
import { ILayoutItem } from '@/types/dashboard'
import { useVModel } from '@vueuse/core'
import useValidationRules from '@/composables/useValidationRules'
import { computed } from 'vue'
import { getLayoutLogo, getLayoutParameterByName } from '@/composables/globalData/useLayouts'
import i18n from '@/i18n'
import RedesignImageUploader from '@/components/RedesignBaseComponents/RedesignImageUploader.vue'
import LayoutGeneralColors from '@/components/RedesignComponents/Layout/Common/LayoutGeneralColors.vue'
import LayoutGeneralFonts from '@/components/RedesignComponents/Layout/Common/LayoutGeneralFonts.vue'

const { required } = useValidationRules()

const props = defineProps<{
    value: ILayoutItem
}>()
const emit = defineEmits<{
    (e: 'input', value: ILayoutItem): void
    (e: 'update:value', value: ILayoutItem): void
}>()

const layoutLocalModel = useVModel(props, 'value', emit, { eventName: 'input' })

const getFavicon = computed(() => {
    const _defaultIcon = String(i18n.t('branding.Favicon'))
    return getLayoutParameterByName(layoutLocalModel.value?.LayoutParametersList || [], 'Favicon', 'ValueText') || _defaultIcon || '/img/no_favicon.svg'
})
const getLogo = computed(() => {
    return getLayoutLogo(layoutLocalModel.value)
})

function onUpdateLogo (logo: string) {
    const params = (layoutLocalModel.value?.LayoutParametersList || []).map(param => {
        if (param.LayoutParameterName === 'DashboardLogo') {
            param.ValueText = logo || getLogo.value
        }
        return param
    })
    layoutLocalModel.value = {
        ...layoutLocalModel.value,
        LayoutParametersList: [ ...params ]
    }
}

function onUpdateFavicon (logo: string) {
    const params = (layoutLocalModel.value?.LayoutParametersList || []).map(param => {
        if (param.LayoutParameterName === 'Favicon') {
            param.ValueText = logo || getLogo.value
        }
        return param
    })
    layoutLocalModel.value = {
        ...layoutLocalModel.value,
        LayoutParametersList: [ ...params ]
    }
}
</script>

